function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Extension } from "@tiptap/core";
import { Suggestion } from "@tiptap/suggestion";
import Fuse from "fuse.js";
import { InsertPhotoOutlined, CodeOutlined, FormatHeader1, FormatHeader2, FormatListNumberedOutlined, FormatQuote, HorizontalRuleOutlined, ListOutlined } from "sprout-ui-icons";
import { modKey } from "sprout-lib/dist/modKey";
import { Plugin } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";
import { findParentNode } from "prosemirror-utils";
const items = [
    {
        title: "Heading",
        keybinding: `${modKey} + ⌥ + 1`,
        icon: /*#__PURE__*/ _jsx(FormatHeader1, {}),
        commandToFire: ({ editor , range  })=>{
            editor.chain().focus().deleteRange(range).setNode("heading", {
                level: 1
            }).run();
        }
    },
    {
        title: "Subheading",
        keybinding: `${modKey} + ⌥ + 2`,
        icon: /*#__PURE__*/ _jsx(FormatHeader2, {}),
        commandToFire: ({ editor , range  })=>{
            editor.chain().focus().deleteRange(range).setNode("heading", {
                level: 2
            }).run();
        }
    },
    {
        title: "Image",
        icon: /*#__PURE__*/ _jsx(InsertPhotoOutlined, {})
    },
    {
        title: "Blockquote",
        keybinding: `${modKey} + ⇧ + B`,
        icon: /*#__PURE__*/ _jsx(FormatQuote, {}),
        commandToFire: ({ editor , range  })=>{
            editor.chain().focus().deleteRange(range).setBlockquote().run();
        }
    },
    {
        title: "Divider",
        keybinding: `${modKey} + _`,
        icon: /*#__PURE__*/ _jsx(HorizontalRuleOutlined, {}),
        commandToFire: ({ editor , range  })=>{
            editor.chain().focus().deleteRange(range).setHorizontalRule().run();
        }
    },
    {
        title: "Bullet List",
        keybinding: `${modKey} + ⌥ + 8`,
        icon: /*#__PURE__*/ _jsx(ListOutlined, {}),
        commandToFire: ({ editor , range  })=>{
            editor.chain().focus().deleteRange(range).toggleBulletList().run();
        }
    },
    {
        title: "Number List",
        keybinding: `${modKey} + ⌥ + 7`,
        icon: /*#__PURE__*/ _jsx(FormatListNumberedOutlined, {}),
        commandToFire: ({ editor , range  })=>{
            editor.chain().focus().deleteRange(range).toggleOrderedList().run();
        }
    },
    {
        title: "Codeblock",
        keybinding: `${modKey} + ⌥ + C`,
        icon: /*#__PURE__*/ _jsx(CodeOutlined, {}),
        commandToFire: ({ editor , range  })=>{
            editor.chain().focus().deleteRange(range).setCodeBlock().run();
        }
    }, 
];
const SlashCommands = Extension.create({
    name: "slashCommands",
    addProseMirrorPlugins () {
        return [
            Suggestion(_objectSpread({
                char: "/",
                startOfLine: true,
                editor: this.editor,
                command: ({ editor , props , range  })=>{
                    // If no match, allow enter to insert new line
                    if (!props) {
                        editor.chain().insertContent({
                            type: "paragraph"
                        }).run();
                        return;
                    }
                    const { commandToFire  } = props;
                    if (commandToFire) commandToFire({
                        editor,
                        range
                    });
                },
                items: ({ query  })=>{
                    if (query.length === 0) return items;
                    const searcher = new Fuse(items, {
                        keys: [
                            "title"
                        ]
                    });
                    const results = searcher.search(query);
                    return results.length >= 1 ? results.map((result)=>result.item) : [];
                }
            }, this.options.suggestion)),
            new Plugin({
                props: {
                    decorations: (state)=>{
                        const { selection  } = state;
                        const parent = findParentNode((node)=>node.type.name === "paragraph")(selection);
                        if (!parent) return undefined;
                        const decorations = [];
                        const isEmpty = parent.node.content.size === 0;
                        const isSlash = parent.node.textContent === "/";
                        const isTopLevel = selection.$from.depth === 1;
                        if (isTopLevel) {
                            if (isEmpty) decorations.push(Decoration.node(parent.pos, parent.pos + parent.node.nodeSize, {
                                class: "placeholder",
                                "data-placeholder": "Type '/' to insert..."
                            }));
                            if (isSlash) decorations.push(Decoration.node(parent.pos, parent.pos + parent.node.nodeSize, {
                                class: "placeholder",
                                "data-placeholder": `  Keep typing to filter...`
                            }));
                            return DecorationSet.create(state.doc, decorations);
                        }
                        return undefined;
                    }
                }
            }), 
        ];
    }
});
export default SlashCommands;
